<script setup lang="ts">
const { feedatyRating, feedatyReviewsCount, feedatyRatingLabel, feedatyReviewsCountLabel } =
  useFeedatyRating()
</script>

<template>
  <p
    v-if="feedatyRating && feedatyReviewsCount"
    class="mouse-bold line-clamp-2 flex items-center justify-center gap-2"
  >
    <UtilsStars :stars="feedatyRating" :size="4" />
    <span>
      {{
        $t("feedaty.stripeSummary", {
          rating: feedatyRatingLabel,
          count: feedatyReviewsCountLabel
        })
      }}
    </span>
  </p>
</template>
